import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from '@mui/material';

const BooleanQuestion = ({ label, value, onChange, error, noLabel }) => {
  const { t } = useTranslation();

  return (
    <FormControl error={error} required>
      <FormLabel>{label}</FormLabel>
      <RadioGroup
        row
        value={value === null ? '' : String(value)}
        onChange={event => onChange(event.target.value === 'true')}>
        <FormControlLabel value="true" control={<Radio />} label={t('showroomProjectRequest.yes')} />
        <FormControlLabel
          value="false"
          control={<Radio />}
          label={noLabel || t('showroomProjectRequest.no')}
          sx={noLabel ? { alignItems: 'flex-start' } : undefined}
        />
      </RadioGroup>
      {error && <FormHelperText>{t('showroomProjectRequest.required')}</FormHelperText>}
    </FormControl>
  );
};

export default BooleanQuestion;
